// extracted by mini-css-extract-plugin
module.exports = {"reactions_wrapper":"GroupPostCardView_reactions_wrapper__1zM-o"};